import { render, staticRenderFns } from "./claim_character.vue?vue&type=template&id=9077d18c"
import script from "./claim_character.vue?vue&type=script&lang=ts"
export * from "./claim_character.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports